export default __webpack_public_path__ + "static/media/general1.8442633a.png";